<template>
  <div class="document-request-corporate-customer">
    <Header :typeComponent="'corporate-customer'"/>
    <v-col>
      <v-row>
        <BaseContentIntro>
          <template v-slot:title>
            <span class="color-title">{{ $t('documentRequest.corporateCustomer.settingsTitle') }}</span>
          </template>
        </BaseContentIntro>
      </v-row>
    </v-col>
    <RequestForMember v-if="corporateCustomerTypeStep === constant.STEP_BY_STEP.STEP_1"
                      @eventChangeRequestForMember="handlerClickReqForCorporate"/>

    <BreadcrumbStep :dataItems="dataBreadcrumbs" @eventChangeStep="handlerClickStep"/>

    <template v-if="corporateCustomerTypeStep === constant.STEP_BY_STEP.STEP_1">
      <p class="step1"></p>
      <MainFormCorporate @eventChangeDataDocReq="handlerMainFormCorporate"
                          :dataModel="dataMainFormCorporate"/>

      <FormDivider/>
      <!-- <FacilityInterested :titleFacilityInterested="'いずれかをお選びください。（複数選択可）'"
                          @eventChangeFacilityInterested="handlerFacilityInterested"
                          :dataModel1="dataFacilityInterestedOptional1"
                          :dataModel2="dataFacilityInterestedOptional2"/>
      <FormDivider/>  -->

      <FindAboutVacations :titleFindAboutVacation="'以下のアンケートにお答えください。'"
                          @eventChangeFindAboutVacation="handlerFindAboutVacation"
                          :dataModel="dataFindAboutVacation"/>

      <PolicyAgree @eventPolicyAgree="handlerPolicyAgree"
                   :dataModel="dataPolicyAgree"/>

      <IfEmailNotReceived />

      <v-col class="d-flex justify-center align-center d-box-act mb-9">
        <v-btn class="btn-action-from pa-0 pl-2" color="primary" :disabled="valid" @click="funcConfirmStep1Form">
          <v-icon x-large right color="white" class="b-right">mdi-chevron-right</v-icon>
          {{ $t('buttons.confirmAndSend') }}
        </v-btn>
      </v-col>
    </template>

    <template v-if="corporateCustomerTypeStep === constant.STEP_BY_STEP.STEP_2">
      <p class="step2"></p>
      <ShowDataCorporateStep2 type="CORPORATE" />

      <v-row class="d-flex justify-center align-center d-box-act mt-4 mb-9">
        <v-col class="d-flex justify-center align-center d-box-act">
          <v-btn class="btn-action-from pa-0 pl-2" text @click="funcBackStep1Form" :disabled="noClickStep2">
            <v-icon x-large right color="white" class="b-right">mdi-chevron-left</v-icon>
            {{ $t('buttons.back') }}
          </v-btn>
        </v-col>
        <v-col class="d-flex justify-center align-center d-box-act">
          <v-btn class="ml-2 btn-action-from pa-0 pl-2" color="primary" @click.prevent="funcSubmitStep2Form" :disabled="noClickStep2">
            <v-icon x-large right color="white" class="b-right">mdi-chevron-right</v-icon>
            {{ $t('buttons.saveAndCreate') }}
            <v-progress-circular v-if="noClickStep2" indeterminate color="primary" :size="18" :width="2"/>
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <template v-if="corporateCustomerTypeStep === constant.STEP_BY_STEP.STEP_3">
      <ShowDataStep3 />
      <!--      <v-col class="d-flex justify-center align-center d-box-act">-->
      <!--        <v-btn class="btn-action-from" text @click="funcAfterSubmitStep3Form">-->
      <!--          <v-icon x-large right color="white" class="b-right">mdi-chevron-right</v-icon>-->
      <!--          TODO: After Submit success ....-->
      <!--        </v-btn>-->
      <!--      </v-col>-->
    </template>

    <Footer :typeComponent="'form'"/>
  </div>
</template>

<script>
import BaseContentIntro from '@/components/common/BaseContentIntro'
import BreadcrumbStep from '@/components/common/BreadcrumbStep'
import PolicyAgree from '@/components/common/PolicyAgree'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import ShowDataCorporateStep2 from '@/components/documentRequest/corporateCustomer/ShowDataCorporateStep2'
import MainFormCorporate from '@/components/documentRequest/corporateCustomer/MainFormCorporate'
import FindAboutVacations from '@/components/common/FindAboutVacations'
import ShowDataStep3 from '@/components/common/ShowDataStep3'
import FormDivider from '@/components/common/FormDivider'
import { mapState } from 'vuex'
import createWebRequest from '@/mixins/createWebRequest'
import RequestForMember from '@/components/documentRequest/client/RequestForMember'
import IfEmailNotReceived from '@/components/common/IfEmailNotReceived'

export default {
  mixins: [
    createWebRequest
  ],
  data () {
    return {
      noClickStep2: false,
      typeValidFindAboutVacation: 'REQ_CHECKBOX_FAV',
      typeValidMainFormCorporate: 'REQ_CHECKBOX_MFC',
      typeValidPolicyAgree: 'REQ_CHECKBOX_PA'
    }
  },
  components: {
    ShowDataStep3,
    ShowDataCorporateStep2,
    FormDivider,
    MainFormCorporate,
    FindAboutVacations,
    BreadcrumbStep,
    BaseContentIntro,
    PolicyAgree,
    Footer,
    Header,
    RequestForMember,
    IfEmailNotReceived
  },
  mounted () {
    this.$store.dispatch('stepCorporateCustomerTypeDispatch', this.constant.STEP_BY_STEP.STEP_1)
    this.typeValidPolicyAgree = this.dataCorporateCustomer.policyAgree ? '' : 'REQ_CHECKBOX_PA'
  },
  computed: {
    ...mapState({
      // Format [stageName] => state.[modulesName].[stageName],
      corporateCustomerTypeStep: state => state.documentRequest.stepCorporateCustomerType
    }),
    dataPolicyAgree () {
      return this.dataCorporateCustomer.policyAgree
    },
    dataFindAboutVacation () {
      return this.dataCorporateCustomer.findAboutVacation
    },
    dataFacilityInterestedOptional1 () {
      return this.dataCorporateCustomer.facilityInterestedOption1
    },
    dataFacilityInterestedOptional2 () {
      return this.dataCorporateCustomer.facilityInterestedOption2
    },
    dataMainFormCorporate () {
      return this.dataCorporateCustomer.mainFormCorporate
    },
    dataBreadcrumbs () {
      return [{
        step: 1,
        name: this.$t('documentRequest.stepByStep.step1'),
        active: this.constant.STEP_BY_STEP.STEP_1 === this.corporateCustomerTypeStep
      }, {
        step: 2,
        name: this.$t('documentRequest.stepByStep.step2'),
        active: this.constant.STEP_BY_STEP.STEP_2 === this.corporateCustomerTypeStep
      }, {
        step: 3,
        name: this.$t('documentRequest.stepByStep.step3'),
        active: this.constant.STEP_BY_STEP.STEP_3 === this.corporateCustomerTypeStep
      }]
    },
    valid () {
      return [
        this.typeValidFindAboutVacation,
        this.typeValidPolicyAgree,
        this.typeValidMainFormCorporate
      ].some(ele => ele.length)
    }
  },
  methods: {
    handlerClickStep (data) {
      // console.log(data)
    },
    handlerPolicyAgree (dataBoolean) {
      this.typeValidPolicyAgree = dataBoolean ? '' : 'REQ_CHECKBOX_PA'
      this.$store.dispatch('policyAgreeDispatch', { policyAgree: dataBoolean, typeApply: this.typeApply })
    },
    handlerClickReqForCorporate (dataObj) {
      this.typeValidForMember = Object.keys(dataObj).length > 0 ? '' : 'REQ_CHECKBOX_RFM'
      this.$store.dispatch('requestForCorporateDispatch', dataObj)
    },
    handlerFindAboutVacation (dataObj) {
      this.typeValidFindAboutVacation = dataObj?.isValid && dataObj.isValid ? '' : 'REQ_CHECKBOX_FAV'
      this.$store.dispatch('findAboutVacationDispatch', { payload: dataObj.data, typeApply: this.typeApply })
    },
    handlerMainFormCorporate (data) {
      this.typeValidMainFormCorporate = data?.isValid && data.isValid ? '' : 'REQ_CHECKBOX_MFC'
      this.$store.dispatch('mainFormCorporateDispatch', data.data)
    },
    handlerFacilityInterested (dataObj) {
      this.$store.dispatch('mainFacilityInterestedDispatch', { payload: dataObj, typeApply: this.typeApply })
    },
    funcConfirmStep1Form () {
      this.$store.dispatch('stepCorporateCustomerTypeDispatch', this.constant.STEP_BY_STEP.STEP_2)
      this.scrollIntoViewSmooth('.step2')
    },
    funcBackStep1Form () {
      this.$store.dispatch('stepCorporateCustomerTypeDispatch', this.constant.STEP_BY_STEP.STEP_1)
      this.scrollIntoViewSmooth('.step1')
    },
    async funcSubmitStep2Form () {
      if (this.noClickStep2) {
        this.showMessageDbClick(this.$toast, 'w', this.$t('common.notSaveWhenDbClick'))
        return
      }
      this.noClickStep2 = true
      const payload = await this.convertDataBeforeCorporateCustomer()

      await this.$store.dispatch('createWebRequestDispatch', {
        apolloClient: this.$apollo,
        payload,
        typeApply: this.typeApply,
        toast: this.$toast
      }).then(res => {
        if (res) {
          this.scrollIntoViewSmooth('.step3')
          return
        }

        // eslint-disable-next-line no-return-assign
        setTimeout(() => this.noClickStep2 = false, 3200)
      })
    },
    funcAfterSubmitStep3Form () {
      // TODO
    }
  },
  created () {
    this.typeApply = 'CORPORATE'
  }
}
</script>

<style lang="scss">

</style>
